import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AllMentorsGridPart } from '../../../../../ui/widget/shared-grids/all-mentors-grid/all-mentors-grid.part';
import { VolunteeringMentorsService } from '../../volunteering-mentors.service';

@Component({
	selector: 'volunteering-all-mentors-view-part',
	standalone: true,
	imports: [AllMentorsGridPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-mentors-view.part.html',
})
export class VolunteeringAllMentorsViewPart {

	readonly pageService = inject(VolunteeringMentorsService);

}